import Image from 'next/image'
import Link from 'next/link'
import React, { useEffect, useState } from 'react'

import { Button, Modal, PageLoading } from '@/components'
import { responovaLogo } from '@/libs/constants/images-library'

type TTNCModal = {
  readonly isOpen: boolean
  readonly hideBranding?: boolean
  readonly isLoading: boolean
  readonly onClose: () => void
}

export default function TNCModal({ isOpen, hideBranding, isLoading, onClose }: TTNCModal) {
  const [isClient, setIsClient] = useState(false)
  const [isChecked, setIsChecked] = useState<boolean>(false)

  const modalTitle = hideBranding ? 'User Agreement' : 'Responova User Agreement'

  const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    return setIsChecked(e.target.checked)
  }

  useEffect(() => {
    setIsClient(true)
  }, [])

  if (!isClient) {
    return null
  }

  if (isLoading) {
    return <PageLoading show />
  }

  return (
    <Modal isOpen={isOpen} title={modalTitle} disableClose>
      <div className='flex flex-col gap-4'>
        {!hideBranding && (
          <Image src={responovaLogo.src} alt={responovaLogo.alt} width={140} height={40} />
        )}
        <p className='text-xs font-normal'>
          Before accessing the survey list, please review and agree to our{' '}
          <Link
            href='/articles/terms-and-condition'
            className='cursor-pointer text-pop-dodger-blue underline'
          >
            Terms and Conditions
          </Link>{' '}
          (T&C) and{' '}
          <Link
            href='/articles/privacy-policy'
            className='cursor-pointer text-pop-dodger-blue underline'
          >
            Privacy Policy
          </Link>{' '}
          (PP) below:
        </p>
        <div className='flex flex-row items-center gap-3'>
          <input type='checkbox' onChange={handleCheckboxChange} data-testid='tnc-checkbox' />
          <p className='text-xs font-normal text-pop-neutral-gray'>
            I confirm my agreement to survey rules and disclaimers
          </p>
        </div>
        <hr />
        <p className='text-xs font-normal'>
          By checking the boxes above, you acknowledge that you have reviewed and accept our T&C and
          PP. Click &quot;Continue&quot; to proceed to the survey list.
        </p>
        <Button
          type='button'
          variant='contained'
          color='primary'
          disabled={!isChecked}
          onClick={onClose}
          disabledVarian='disabled'
          aria-label='Continue'
        >
          Continue
        </Button>
      </div>
    </Modal>
  )
}
